<template>
  <Modal
    name="target-steps"
    title="Моя цель шагов"
    :active="active"
    :class="{ 'for-mobile-app': isMobileApp }"
    :noTransition="true"
    @close.prevent="onTargetStepsClose"
    class="target-steps__modal"
  >
    <Link @click="$emit('target-steps-info')" text="Как выбрать количество шагов"></Link>
    <div class="target-steps__modal-count">
      <Button
        variant="secondary"
        size="lg"
        :disabled="localStepsCount <= 1000"
        @click="onDiminishCount"
      >
        <Icon name="minus" size="l"></Icon>
      </Button>
      <div class="target-steps__modal-input">
        <Input
          v-model="localStepsCount"
          name="text"
          readonly
        ></Input>
      </div>
      <Button
        variant="secondary"
        size="lg"
        text=""
        @click="onAddCount"
      >
        <Icon name="plus" size="l"></Icon>
      </Button>
    </div>
    <div class="target-steps__modal-bottom">
      <Button
        variant="primary"
        size="lg"
        text="Установить цель"
        mobile
        @click="onSetTarget"
      ></Button>
      <span>Цель применится к сегодняшнему и&nbsp;последующим дням</span>
    </div>
  </Modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Input from '@rr-component-library/input/src/main';

export default {
  name: 'TargetStepModal',
  components: {
    Input,
  },
  props: {
    isMobileApp: Boolean,
    active: {
      type: Boolean,
      default: false,
    },
    stepsCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      localStepsCount: this.stepsCount,
    };
  },
  watch: {
    stepsCount(newVal) {
      this.localStepsCount = newVal;
    },
  },
  methods: {
    ...mapActions('steps', ['getSteps', 'setTargetSteps']),
    onTargetStepsClose() {
      this.$emit('close');
    },
    onAddCount() {
      this.localStepsCount += 1000;
    },
    onDiminishCount() {
      if (this.localStepsCount <= 1000) return;
      this.localStepsCount -= 1000;
    },
    onSetTarget() {
      this.$emit('change-target', this.localStepsCount);
    },
    onShowAlert() {
      this.$emit('show-alert');
    },
  },
  computed: {
    ...mapGetters('steps', ['steps']),
  },
};
</script>

<style lang="scss" scoped>
@import './TargetStepModal';
</style>
